// useDropdown.ts
import { useCallback, useEffect, useRef, useState } from 'react';

const CLOSE_DELAY_MS = 200;

export const useDropdown = (disableXPositioning = false, dropdownTop = '8px') => {
  const [isOpen, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: '50px', left: 0 });
  const dropdownRef = useRef(null);
  const initiatorRef = useRef(null);
  const closeTimerRef = useRef(null);

  const calculatePosition = useCallback(() => {
    const dropdownElement = dropdownRef.current;
    const initiatorElement = initiatorRef.current;
    if (dropdownElement && initiatorElement) {
      const initiatorRect = initiatorElement.getBoundingClientRect();
      const dropdownWidth = dropdownElement.offsetWidth;
      const initiatorWidth = initiatorElement.offsetWidth;
      const windowWidth = window.innerWidth;

      // Кнопка "Ещё": fixed, под кнопкой с отступом dropdownTop (отступ от низа кнопки)
      if (disableXPositioning) {
        const gapPx = parseInt(String(dropdownTop).replace(/px$/, ''), 10) || 0;
        const topPx = initiatorRect.bottom + gapPx;
        const leftPx = initiatorRect.left;
        setPosition({
          position: 'fixed',
          top: topPx,
          left: leftPx,
        });
        return;
      }

      const checkRightEdge = initiatorRect.left + initiatorWidth / 2 + dropdownWidth / 2;
      const rightEdge = initiatorRect.left + initiatorWidth / 2 - dropdownWidth / 2;

      if (checkRightEdge > windowWidth) {
        setPosition({ top: '50px', left: windowWidth - dropdownWidth - 10 });
      } else {
        setPosition({ top: '50px', left: rightEdge });
      }
    }
  }, [disableXPositioning, dropdownTop]);

  useEffect(() => {
    calculatePosition();
    window.addEventListener('resize', calculatePosition);
    return () => {
      window.removeEventListener('resize', calculatePosition);
    };
  }, [calculatePosition]);

  useEffect(() => {
    if (isOpen) {
      calculatePosition();
    }
  }, [isOpen, calculatePosition]);

  const handleMouseOver = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setOpen(true);
  };

  const handleMouseLeave = () => {
    closeTimerRef.current = setTimeout(() => setOpen(false), CLOSE_DELAY_MS);
  };

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    };
  }, []);

  return {
    isOpen,
    position,
    dropdownRef,
    initiatorRef,
    handleMouseOver,
    handleMouseLeave,
  };
};
